<!-- Builder Start -->
<div id="{{position}}" class="position-relative" >
    <div class="feature-light-bg"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div class="feature-title pt-40">
        <h1 [class]="'center mb-60 '+titleSize"
          [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor,'font-weight':fontWeight }">
          {{title}}</h1>
      </div>
      
      <div fxLayout="column" fxLayout.gt-sm="row">
        <div fxFlex style="margin-right: 10px ;" *ngFor="let feature of features; let featureIndex=index">
          <div class="feature-image-container">
            <div [ngClass]="{
              'text-center': feature.textAlign == 'center',
              'text-left': feature.textAlign == 'left',
              'text-right': feature.textAlign == 'right'
            }">
            <div class="feature-image-class" [ngStyle]="{'border-radius': feature.borderRadius+'px','background-image':'url('+feature.image+');' }"></div>
            <h3
              [ngStyle]="{ 'font-family': getTitleFontFamilyName(feature.titleFontFamily) ,'color': feature.titleColor ? feature.titleColor : feature.textColor ? feature.textColor : '#000000' }"
              [innerHtml]="feature.title | safeHtml"></h3>
            <p [ngStyle]="{ 'color': feature.textColor ? feature.textColor :'#000000' }"
              [innerHtml]="feature.text | safeHtml"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>

<img *ngFor="let feature of features; let featureIndex=index" style="display: none;" [src]="feature.image" class="hero-image" [alt]="title" >